import { Anrede, Domaenenwert, Wechselgrund, WechselGrund } from '@ps20/bff-models';
import { StandaloneProdukt, Vorvertrag } from './vorvertrag';
import { App } from './ps20apps';
import { areAppTypesEquivalent } from './app-type-config';
import { FEVorvertragsnummer } from './vertragsoptionen';

interface AuswahlElement<T, V> {
  textKey: T;
  value: V;
}

export type VnWechselGrundAuswahlElement = AuswahlElement<string, WechselGrund>;

export interface FremdVN {
  anrede: Anrede;
  vorname: string;
  nachname: string;
  akadgrad: Domaenenwert;
  adelsbez: Domaenenwert;
  adresse: {
    strasse: string;
    hausnummer: string;
    plz: string;
    ort: string;
    land?: Domaenenwert;
  };
}

export interface FremdVNVorvertrag {
  vorvertragsnummer: FEVorvertragsnummer;
  vnWechselGrund?: Array<VnWechselGrund>;
  wasSelectedInVwg?: boolean;
}

export interface VnWechselGrund {
  appId: App;
  value?: WechselGrund;
  text?: string;
}

export interface VnWechselAngabenElement {
  fremdVn: FremdVN;
  fremdVNVorvertraege: Array<FremdVNVorvertrag>;
}

export interface VnWechselVertraegeAendern {
  fremdVn: FremdVN;
  addVertraege: Array<FremdVNVorvertrag>;
  removeVertraege: Array<FremdVNVorvertrag>;
  isWeitererVertrag?: boolean;
}

export interface VnWechselAngaben {
  vnWechselGrundAngabenVorhanden: boolean;
  angabenListe: Array<VnWechselAngabenElement>;
  vnWechselgrundList: Array<Wechselgrund>;
}

export function mapFremdVNVorvertraege(
  vorvertraege: Array<Vorvertrag | StandaloneProdukt>,
): Array<FremdVNVorvertrag> {
  return vorvertraege.map(vorvertrag => {
    const vertrag = vorvertrag as Vorvertrag;
    return {
      vorvertragsnummer: {
        vertragsnummer: vorvertrag.vertragsnummer,
        spLaufnummer: vorvertrag.spLaufnummer,
        produktIds: vertrag.produktIds,
      },
    };
  });
}

export function compareProductIdsIfExistingAndSpLaufnrNotExists(
  produktId1: App[],
  produktId2: App[] | string[],
  spLaufnr1: number,
  spLaufnr2: number,
): boolean {
  if (spLaufnr1 || spLaufnr2) {
    return spLaufnr1 === spLaufnr2;
  }
  return (
    Boolean(produktId1) &&
    Boolean(produktId2) &&
    produktId1.length === produktId2.length &&
    produktId1.every((produktId, index) =>
      areAppTypesEquivalent(produktId, produktId2[index] as App),
    )
  );
}
